import { render, staticRenderFns } from "./XpSettings.vue?vue&type=template&id=c51491ce"
import script from "./XpSettings.vue?vue&type=script&lang=js"
export * from "./XpSettings.vue?vue&type=script&lang=js"
import style0 from "./XpSettings.vue?vue&type=style&index=0&id=c51491ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports